/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import axios, { AxiosInstance } from "axios";
import { CoreAPI_URLs } from "constants/http.const";
import { HeaderEnum, StorageEnum } from "medicalsystem-shared";
import { GenericHTTPResponseInterface } from "medicalsystem-shared";

/**
 * Configured Axios instance with authentication and error handling interceptors.
 * Automatically adds JWT token, user ID, API key, and base URL to all requests.
 * Handles wrapped API responses and transforms errors for consistent error handling.
 */
const axiosInstance: AxiosInstance = axios.create();

axiosInstance.interceptors.request.use((config) => {
  const accessToken = window.localStorage.getItem(StorageEnum.ACCESS_TOKEN_ID);
  const id = window.localStorage.getItem(HeaderEnum.USER_ID);
  config.baseURL = process.env.REACT_APP_API_BASE_URL;
  config.headers.set(HeaderEnum.API_KEY, process.env.REACT_APP_API_KEY);
  config.headers.setContentType(
    config.url == CoreAPI_URLs.ASSETS_UPLOAD
      ? HeaderEnum.CONTENT_TYPE_UPLOAD
      : HeaderEnum.CONTENT_TYPE
  );
  if (accessToken && accessToken !== null) {
    config.headers.setAuthorization(`Bearer ${accessToken}`);
  }
  if (config.headers.get(HeaderEnum.USER_ID) === undefined) {
    config.headers.set(HeaderEnum.USER_ID, id);
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    const responseData = response.data;
    if (responseData && typeof responseData === 'object' && 'success' in responseData) {
      const wrappedResponse = responseData as GenericHTTPResponseInterface<any>;
      if (!wrappedResponse.success) {
        const error = new Error(wrappedResponse.message || 'Server error');
        (error as any).status = wrappedResponse.status;
        (error as any).response = {
          ...response,
          status: wrappedResponse.status,
          data: wrappedResponse
        };
        return Promise.reject(error);
      }
    }
    return response;
  },
  (error) => {
    if (error.response?.data) {
      const responseData = error.response.data; 
      if (responseData && typeof responseData === 'object' && 'success' in responseData) {
        const wrappedError = responseData as GenericHTTPResponseInterface<any>;
        error.wrappedError = wrappedError;
      }
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
